
import React, { useContext, useState, useMemo, useCallback } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import moment from 'moment';
import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { withRouter } from 'react-router-dom';
import { MLModalService } from 'ml-portals-services-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { MLAlertGroupComponent } from 'ml-components-common-react';
import { useDataRefresh, ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { ClaimService } from 'gw-capability-claim';
import { MLTable }  from 'gw-capability-fnol-common-react';
import { FormModalPopover } from 'ml-components-platform-react';
import headerLogo from 'ml-digital-theme-styles/images/farmers/farmers-foremost-logo.png'

import confirmationModal from './MLClaimCareShopsContactModal.metadata.json5'
import confirmationModalStyles from './MLClaimCareShopsContactModal.module.scss'
import schedulesModal from './MLClaimCareShopsSchedulesModal.metadata.json5'

import metadata from './MLClaimSelfServeCareShops.metadata.json5';
import messages from './MLClaimSelfServeCareShops.messages';
import styles from './MLClaimSelfServeCareShops.module.scss';

import { Button } from '@jutro/legacy/components';

import { IntlContext } from '@jutro/legacy/locale';

function MLClaimSelfServeCareShops(props) {
    const modalApi = useModal();
    const {
        location,
        history
    } = props;
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const intl = useContext(IntlContext)
    const { authHeader } = useAuthentication();
    const ModalService = MLModalService();
    const { refreshData } = useDataRefresh();

    const {
        claimNumber,
        insuredVehicleIncident,
        isServiceRequestMade,
        searchCriteria
    } = location.state || {};

    const [ repairShopSearchCriteriaView, updateRepairShopSearchCriteriaView ] = useState(
        viewModelService.create({
            address: searchCriteria.address
        }, 'cc', 'metlife.edge.capabilities.claim.selfserve.dto.AppraiserSearchCriteriaDTO')
    )
    const [ searched, updateSearched ] = useState(false);
    const rowLimit = useMemo(() => 10, []);
    const showDays = useMemo(() => 6, []);
    const [ appraisersPaginationInfo, updateAppraisersPaginationInfo] = useState({
        currentPage: 1
    });
    const [ appraisers, updateAppraisers ] = useState([]);
    const [ appraiserSchedules, updateAppraiserSchedules ] = useState();
    const [ currentView, updateCurrentView ] = useState();
    const [ isMoveLeftAvailable, updateIsMoveLeftAvailable ] = useState();
    const [ isMoveRightAvailable, updateIsMoveRightAvailable ] = useState();
    const [ selectedTimeSlot, updateSelectedTimeSlot ] = useState();
    const [ currentViewIndex, updateCurrentViewIndex] = useState();
    const [ currentAppraiser, updateCurrentAppraiser ] = useState();
    const [ scheduleModal, updateScheduleModal] = useState(false);

    const onModelChange = () => {
        const newVM = viewModelService.clone(repairShopSearchCriteriaView);
        updateRepairShopSearchCriteriaView(newVM);
    }


    const _getCurrentPageDisplay = (data = appraisers, currentPage = appraisersPaginationInfo.currentPage) => {
        const startPoint = ((currentPage - 1) * rowLimit);
        const endPoint = (rowLimit * currentPage);
        return data.slice(startPoint, endPoint);
    };

    const _setPaginationInfo = (data) => {
        const _appraisersPaginationInfo = {
            currentPage: 1,
            totalItems: data.length,
            maxSize: rowLimit,
            data: _getCurrentPageDisplay(data, 1)
        }
        updateAppraisersPaginationInfo(_appraisersPaginationInfo);
    };

    const searchRepairShops = ()=> {
        updateSearched(false);
        updateAppraisers([]);
        const appraisersPromise = ClaimService.searchAppraisers(repairShopSearchCriteriaView.value, authHeader);
        ModalService.showProgressDialog(messages.SearchingRepairShops, appraisersPromise);
        appraisersPromise
            .then((_appraisers)=> {
                updateAppraisers(_appraisers);
                _setPaginationInfo(_appraisers);
            })
            .then(()=> {
                updateSearched(true);
            })
            .catch(()=> {
                ModalService.showErrorModal(messages.ErrorRetrievingRepairShops, ' ');
            });
    };

    const _confirm = (appraiser) => {
        const appraiserServiceRequest = ClaimService.cccServiceRequestForAppraiser(claimNumber, appraiser, authHeader);
        ModalService.showProgressDialog(messages.RequestingService, appraiserServiceRequest);
        appraiserServiceRequest.then((appraiserService)=> {
            if (appraiserService === 'SUCCESS') {
                setTimeout(() => {
                    ModalService.showErrorModal(messages.ServiceRequest, messages.ServiceRequestCreatedSuccessfully);
                    history.push(`/claims/${claimNumber}`)
                }, 100);
            }
        }).catch(()=> {
            setTimeout(() => {
                ModalService.showErrorModal(messages.ErrorRequestingService, ' ');
            }, 100);
            
        });
    }

    const _showConfirmationDialog = (appraiser) => {
        return modalApi.showModal(
            <FormModalPopover
                showHeader
                actionBtnLabel={translator(messages.Confirm)}
                cancelBtnLabel={translator(messages.Cancel)}
                uiProps={confirmationModal.pageContent}
                modalBodyStyles={confirmationModalStyles}
                overrideProps={{
                    logo: {
                        src: headerLogo
                    },
                    appraiserName: {
                        content: appraiser.appraiserName,
                    },
                    addressLine: {
                        content: appraiser.addressLine,
                    },
                    phone: {
                        content: appraiser.phone,
                    }
                }}

            />
        ).then(() => setTimeout(() => _confirm(appraiser), 100)).catch(_.noop);
    };

    const _getCurrentView = useCallback((_appraiserSchedules, _currentViewIndex) => {
        const views = [];
        _appraiserSchedules.forEach((appraiserSchedule) => {
            const view = {
                windowStartTime: '',
                availability: []
            };
            const parts = appraiserSchedule.windowStartTime.split(':');
            view.windowStartTime = new Date();
            view.windowStartTime.setHours(parts[0]);
            view.windowStartTime.setMinutes(parts[1]);
            view.availability = [];
            for (let i = _currentViewIndex; i < _currentViewIndex + showDays; i += 1) {
                view.availability.push(appraiserSchedule.availability[i]);
            }
            views.push(view);
        });
        return views;
    }, [showDays]);

    const _changeView = useCallback((direction) => {
        let _currentViewIndex;
        if (direction === 'left') {
            _currentViewIndex = currentViewIndex - showDays
            updateCurrentViewIndex(_currentViewIndex);
            updateIsMoveRightAvailable(true);
        } else if (direction === 'right') {
            _currentViewIndex = currentViewIndex + showDays
            updateCurrentViewIndex(_currentViewIndex);
            updateIsMoveLeftAvailable(true);
        }

        updateCurrentView(_getCurrentView(appraiserSchedules, _currentViewIndex));

        if (_currentViewIndex === 0) {
            updateIsMoveLeftAvailable(false);
        }
        if (appraiserSchedules[0].availability.length === _currentViewIndex + showDays) {
            updateIsMoveRightAvailable(false);
        }
    }, [_getCurrentView, appraiserSchedules, currentViewIndex, showDays]);

    const _onTimeSlotSelect = (date, timeSlot) => {
        if (date.available) {
            const minutes = timeSlot.windowStartTime.getMinutes() === '0' ? `${timeSlot.windowStartTime.getMinutes()}0` : timeSlot.windowStartTime.getMinutes();
            updateSelectedTimeSlot(`${date.date.split('T')[0]}T${timeSlot.windowStartTime.getHours()}:${minutes}:00.000-05:00`);
        }
    };

    const _dialogInit = (_appraiserSchedules) => {
        updateIsMoveLeftAvailable(false);
        if (_appraiserSchedules[0].availability.length > showDays) {
            updateIsMoveRightAvailable(true);
        }else{
            updateIsMoveRightAvailable(false);
        }
    };

    const getViewDate = (date) => {
        if(date){
            return moment(new Date(date)).format("ddd MM/DD")
        }
        return ""
    }

    const getTimeSlotStartTime = (windowStartTime) => {
        if(windowStartTime){
            return moment(windowStartTime).format("hh:mm a")
        }
        return ""
    }

    const bookAppointmentDisabled = useCallback(() => {
        return selectedTimeSlot === undefined;
    }, [selectedTimeSlot]);

    const getScheduleTableRows = useCallback((timeSlot) => {
        return <>
            { timeSlot.availability.map((date) => 
                <div className="cell">
                    <Button type="outlined" onClick={() => _onTimeSlotSelect(date, timeSlot)} disabled={!date.available}>
                        {getTimeSlotStartTime(timeSlot.windowStartTime)}
                    </Button>
                </div>)
            }
        </>
    }, []);

    const getScheduleDateOVerrides = useCallback((_currentView) => {
        const overrides = _currentView[0].availability.map((view, index) => {
            return {
                [`viewDate${index}`]: {
                    content: getViewDate(view.date)
                }
            }          
        });

        return Object.assign({}, ...overrides);
    }, []);

    const getScheduleTimeSlotOVerrides = useCallback((_currentView) => {
        const overrides = _currentView.map((timeSlot, index) => {
            return {
                [`tableRow${index}`]: {
                    content: getScheduleTableRows(timeSlot)
                }
            }          
        });

        return Object.assign({}, ...overrides);
    }, [getScheduleTableRows]);

    const getScheduleModalOverrideProps = useCallback(() => {
        if(!currentAppraiser || !currentView){
            return {}
        }
        return {
            appraiserName: {
                content: currentAppraiser.appraiserName,
            },
            addressLine: {
                content: currentAppraiser.addressLine,
            },
            phone: {
                content: currentAppraiser.phone,
            },
            buttonLeft: {
                className: cx(confirmationModalStyles["schedule-table-button"], confirmationModalStyles.prev, { [confirmationModalStyles.inactive] : !isMoveLeftAvailable}),
                onClick: () => _changeView('left'),
                disabled: !isMoveLeftAvailable
            },
            buttonsMiddleIterator: {
                data: currentView[0].availability || []
            },
            buttonRight: {
                className: cx(confirmationModalStyles["schedule-table-button"], confirmationModalStyles.next, { [confirmationModalStyles.inactive] : !isMoveRightAvailable}),
                onClick: () => _changeView('right'),
                disabled: !isMoveRightAvailable
            },
            tableRowIterator: {
                data: currentView
            },

            ...getScheduleDateOVerrides(currentView),
            ...getScheduleTimeSlotOVerrides(currentView)
        }
    }, [_changeView, currentAppraiser, currentView, getScheduleDateOVerrides, getScheduleTimeSlotOVerrides, isMoveLeftAvailable, isMoveRightAvailable])

    const _showScheduleDialog = (_appraiserSchedules, _currentView) => {
        if (_appraiserSchedules !== undefined && _currentView !== undefined) {
            _dialogInit(_appraiserSchedules);
            updateScheduleModal(true);
        }
    };

    const _bookAppointment = () => {
        const bookAppointmentRequest = ClaimService.bookAppraiserAppointment(claimNumber, selectedTimeSlot, currentAppraiser, authHeader);
        ModalService.showProgressDialog(messages.RequestingService, bookAppointmentRequest);
        bookAppointmentRequest.then((bookAppointment)=> {
            if (bookAppointment === 'SUCCESS') {
                ModalService.showErrorModal(messages.BookAppointment, messages.YourAppointmentBookedSuccessfully);
                updateScheduleModal(false);
                history.push(`/claims/${claimNumber}`)
            }
        }).catch(()=> {
            ModalService.showErrorModal(messages.BookAppointmentError);
            updateScheduleModal(false);
        });
    };

    const _cancelBookAppointment = () => {
        updateScheduleModal(false);
    }

    const selectRepairShop = (appraiser) => {
        if (appraiser.appointmentScheduling && insuredVehicleIncident.safeToDrive) {
            let appraiserSchedulesPromise = null;
            if (appraiser.value) {
                appraiserSchedulesPromise = ClaimService.getAppraiserSchedule(claimNumber, appraiser.value, authHeader);
            } else {
                appraiserSchedulesPromise = ClaimService.getAppraiserSchedule(claimNumber, appraiser, authHeader);
            }
            ModalService.showProgressDialog(messages.RetrievingSchedule, appraiserSchedulesPromise);
            appraiserSchedulesPromise.then((_appraiserSchedules)=> {
                updateAppraiserSchedules(_appraiserSchedules);
                updateCurrentViewIndex(0);
                updateSelectedTimeSlot();
                let _currentView;
                if (_appraiserSchedules !== undefined) {
                    _currentView = _getCurrentView(_appraiserSchedules, 0)
                    updateCurrentView(_currentView);
                    
                }
                updateCurrentAppraiser(appraiser);
                _showScheduleDialog(_appraiserSchedules, _currentView);
            }).catch((e)=> {
                console.error(e);
                ModalService.showErrorModal(messages.ErrorRetrievingSchedules);
            });
        } else {
            _showConfirmationDialog(appraiser);
        }
    }

    const getStrongCell = (data) => {
        return <strong>{data.appraiserName}</strong>
    }

    const rentalCarLocation = (data) => {
        const rentalCarAvailable = data.rentalCarAvailable;
        return rentalCarAvailable === 'Unknown' ? '' : rentalCarAvailable
    }

    const getSelectButton = (data) => {
        return <Button type="outlined" disabled={isServiceRequestMade} onClick={() => selectRepairShop(data)}>
            {translator(messages.Select)}
        </Button>
    }

    const setPage = (page) => {
        const _appraisersPaginationInfo = {...appraisersPaginationInfo}
        _appraisersPaginationInfo.currentPage = page;
        _appraisersPaginationInfo.data = _getCurrentPageDisplay(appraisers, _appraisersPaginationInfo.currentPage);
        updateAppraisersPaginationInfo(_appraisersPaginationInfo);
    }

    const overrideProps = {
        searchResultsContainer: {
            visible: appraisers.length > 0
        },
        searchResults: {
            data: appraisersPaginationInfo.data || [],
            itemCount: appraisersPaginationInfo.totalItems,
            itemsPerPage: appraisersPaginationInfo.maxSize,
            currentPage: appraisersPaginationInfo.currentPage,
            setPage
        },
        noAppraisersContent: {
            visible: searched && appraisers.length === 0
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            MLAlertGroupComponent,
            MLTable
        },
        resolveCallbackMap: {
            searchRepairShops,
            getStrongCell,
            rentalCarLocation,
            getSelectButton
        }
    };

    return (
        <>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={repairShopSearchCriteriaView}
                onModelChange={onModelChange}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
            <FormModalPopover
                isOpen={scheduleModal}
                onResolve={_bookAppointment}
                onReject={_cancelBookAppointment}
                showHeader
                title={messages.ScheduleAppointment}
                subtitle={messages.ScheduleAppointmentModalSubtitle}
                actionBtnLabel={translator(messages.BookAppointment)}
                cancelBtnLabel={translator(messages.Cancel)}
                uiProps={schedulesModal.pageContent}
                getOverrideProps={getScheduleModalOverrideProps}
                disableButton={bookAppointmentDisabled}
            />
        </>
    )
}

export default withRouter(MLClaimSelfServeCareShops);
